import 'bootstrap/dist/css/bootstrap.css';
import { reactPlugin } from "./telemetry/appInsights";
import { AppInsightsContext } from "@microsoft/applicationinsights-react-js";
import React from 'react';
import ReactDOM from 'react-dom';

import { MsalProvider, MsalAuthenticationTemplate } from "@azure/msal-react";
import { InteractionType,  PublicClientApplication } from "@azure/msal-browser";

import App from './App';
import { authRequest, msalInstance } from './authConfig';

function ErrorComponent({error}) {
  return <p>An Error Occurred: {JSON.stringify(error)}</p>;
};

function LoadingComponent() {
  return <p>Authentication in progress...</p>;
};

// Component
const AppProvider = () => (
  <AppInsightsContext.Provider value={reactPlugin}>
    <MsalProvider instance={msalInstance}>
      <React.StrictMode>
        <MsalAuthenticationTemplate
          interactionType={InteractionType.Popup}
          authenticationRequest={authRequest}
          errorComponent={ErrorComponent}
          loadingComponent={LoadingComponent} 
        >
          <App />
        </MsalAuthenticationTemplate>
      </React.StrictMode>
    </MsalProvider>
  </AppInsightsContext.Provider>
)

ReactDOM.render(
  <AppProvider />,
  document.getElementById('root')
);


